
    
    @if (showAddTargetData && selectedTarget()) {
      <div class="supervisor-dialog-backdrop" (click)="hideAddData()"></div>
      <dialog class="supervisor-dialog" open>
        <app-add-target-data [selectedPatientID]="selectedTarget().PatientID!" [target]="selectedTarget()" [hideTargetSelector]="true"
          (close)="onCloseAddData($event)" />
      </dialog>
      }
    <div class="filter-container mb-3">
      
      <div class="filter-row d-flex justify-content-end">
        <div class="filter-item">
          <button 
            pButton 
            type="button" 
            label="Add Data" 
            class="btn btn-primary" 
            (click)="addData()"
          ></button>
        </div>
      </div>
      <div class="filter-row">
        <div class="filter-item">
          <label for="startDate">Start Date</label>
          <input 
            id="startDate"
            type="date" 
            pInputText 
            [(ngModel)]="startDate" 
          />
        </div>
        <div class="filter-item">
          <label for="endDate">End Date</label>
          <input 
            id="endDate"
            type="date" 
            pInputText 
            [(ngModel)]="endDate" 
          />
        </div>
        <div class="filter-item">
          <label for="showDeleted">Show Deleted</label>
          <p-checkbox
            id="showDeleted"
            [(ngModel)]="showDeleted" 
            [binary]="true"
          />
        </div>
        <div class="filter-item">
          <button 
            pButton 
            type="button" 
            label="Filter" 
            class="btn btn-primary" 
            (click)="filterData()"
          ></button>
        </div>
      </div>
    </div>

    <p-table #dt [value]="targetsData" dataKey="ID" editMode="row" [attr.inert]="savingData ? '' : null" [loading]="savingData">
      <ng-template pTemplate="header">
        <tr>
          <th>Session</th>
          <th>Recorded Date</th>
          <th>Value</th>
          <th>Created By</th>
          <th>Modified By</th>
          <th>Modified Date</th>
          <th style="width: 2rem"></th>
          <th style="width: 2rem"></th>
        </tr>
      </ng-template>
      <ng-template
        pTemplate="body"
        let-targetData
        let-editingTargetData="editing"
        let-targetDataIndex="rowIndex"
      >
        <tr [pEditableRow]="targetData" [class.deleted]="!!targetData.DeletedDate" >
          <td>
            @if (targetData.SessionData) {
            Session on {{ targetData.SessionData?.StartedDate | date : "MM/dd/yyyy HH:mm" }} - {{ targetData.SessionData?.FinishedDate | date : "MM/dd/yyyy HH:mm" }}
              @if (targetData.SessionData?.ServiceID) {
                <br>
                {{ targetData.SessionData?.ServiceID ? 'Service: #' + targetData.SessionData?.ServiceID : '' }} 
              }
            }
          </td>
          
          <td class="position-relative">
            @if (targetData.DeletedDate) {
            <span class="badge-delete-rawdata">Deleted</span>
          } 
            <p-cellEditor>
              <ng-template pTemplate="input">
                <input
                  pInputText
                  type="datetime-local"
                  step="1"
                  [(ngModel)]="targetData.RecordedDate"
                />
              </ng-template>
              <ng-template pTemplate="output">
                {{ targetData.RecordedDate | date : "MM/dd/yyyy HH:mm" }}
              </ng-template>
            </p-cellEditor>
          </td>

          @if (targetIsPromptBased(targetData)) { 
            @if (targetIsEchoic(targetData)) {
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      class="pe-1"
                      [options]="promptOptionsForTarget(targetData)"
                      [(ngModel)]="targetData.IntValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                    <p-dropdown
                      [options]="extraOptionsForEchoicTarget(targetData)"
                      [(ngModel)]="targetData.TextValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <p-tag
                      class="pe-1"
                      [style]="{
                        background: firstColorForEchoic(targetData)
                      }"
                      [value]="firstTextForEchoic(targetData)"
                    />
                    <p-tag
                      [style]="{ background: secondColorForEchoic(targetData) }"
                      [value]="secondTextForEchoic(targetData)"
                    />
                  </ng-template>
                </p-cellEditor>
              </td>
              } @else {
              <td>
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-dropdown
                      [options]="promptOptionsForTarget(targetData)"
                      [(ngModel)]="targetData.IntValue"
                      [checkmark]="true"
                      optionLabel="text"
                      optionValue="value"
                    />
                  </ng-template>
                  <ng-template pTemplate="output">
                    <p-tag
                      [style]="{ background: valueColorForTarget(targetData) }"
                      [value]="valueTextForTarget(targetData)"
                    />
                  </ng-template>
                </p-cellEditor>
              </td>
              } 
          } @else if (targetIsToileting(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="targetData.TextValue"
                  />
                  <div class="toileting-checkboxes" style="display: flex; gap: 1rem; margin-top: 0.5rem;">
                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-urination-on-edit-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.UrinationOn"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="rawdata-toileting-urination-on-edit-{{ targetData.ID }}" class="ml-2">Urination On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-urination-off-edit-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.UrinationOff"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="rawdata-toileting-urination-off-edit-{{ targetData.ID }}" class="ml-2">Urination Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-bowel-on-edit-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.BowelMovementOn"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="rawdata-toileting-bowel-on-edit-{{ targetData.ID }}" class="ml-2">BM On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-bowel-off-edit-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.BowelMovementOff"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="rawdata-toileting-bowel-off-edit-{{ targetData.ID }}" class="ml-2">BM Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-no-void-edit-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.NoVoid"
                        styleClass="app-checkbox">
                      </p-checkbox>
                      <label for="rawdata-toileting-no-void-edit-{{ targetData.ID }}" class="ml-2">No Void</label>
                    </span>
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                  <div class="toileting-checkboxes" style="display: flex; gap: 1rem; margin-top: 0.5rem;">
                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-urination-on-view-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.UrinationOn"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="rawdata-toileting-urination-on-view-{{ targetData.ID }}" class="ml-2">Urination On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-urination-off-view-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.UrinationOff"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="rawdata-toileting-urination-off-view-{{ targetData.ID }}" class="ml-2">Urination Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-bowel-on-view-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.BowelMovementOn"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="rawdata-toileting-bowel-on-view-{{ targetData.ID }}" class="ml-2">BM On</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-bowel-off-view-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.BowelMovementOff"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="rawdata-toileting-bowel-off-view-{{ targetData.ID }}" class="ml-2">BM Off</label>
                    </span>

                    <span>
                      <p-checkbox
                        inputId="rawdata-toileting-no-void-view-{{ targetData.ID }}"
                        [binary]="true"
                        [(ngModel)]="targetData.ToiletingData.NoVoid"
                        styleClass="app-checkbox"
                        disabled>
                      </p-checkbox>
                      <label for="rawdata-toileting-no-void-view-{{ targetData.ID }}" class="ml-2">No Void</label>
                    </span>
                  </div>
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsWholePartialInterval(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-checkbox
                    [binary]="true"
                    [(ngModel)]="wholePartialIntervalHappened"
                    label="Happened"
                    styleClass="app-checkbox"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsFluencyRate(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="d-flex flex-column gap-2">
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="fluencyCorrectCount"
                      placeholder="Correct Count"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="fluencyIncorrectCount"
                      placeholder="Incorrect Count"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0.016667"
                      [minFractionDigits]="1"
                      [maxFractionDigits]="2"
                      suffix=" minutes"
                      [(ngModel)]="fluencyDurationInMinutes"
                      placeholder="Duration"
                    />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsRate(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <div class="d-flex flex-column gap-2">
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0"
                      [(ngModel)]="rateOccurrenceCount"
                      placeholder="Occurrences"
                    />
                    <p-inputNumber
                      autoWidth="false"
                      [style]="{ width: '100%' }"
                      [showButtons]="true"
                      [min]="0.016667"
                      [minFractionDigits]="1"
                      [maxFractionDigits]="2"
                      suffix=" minutes"
                      [(ngModel)]="fluencyDurationInMinutes"
                      placeholder="Duration"
                    />
                  </div>
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsDuration(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [minFractionDigits]="1"
                    [maxFractionDigits]="2"
                    suffix=" minutes"
                    [(ngModel)]="targetDurationInMinutes"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsIntValueOnly(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [(ngModel)]="targetData.IntValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsIntensity(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-selectButton
                    [(ngModel)]="targetData.IntValue"
                    [options]="targetIntensityOptions()"
                    optionLabel="label"
                    optionValue="value"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          } @else if (targetIsFrequency(targetData)) {
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <p-inputNumber
                    autoWidth="false"
                    [style]="{ width: '100%' }"
                    [showButtons]="true"
                    [min]="0"
                    [(ngModel)]="targetData.IntValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          }
           @else {            
            <td>
              <p-cellEditor>
                <ng-template pTemplate="input">
                  <input
                    pInputText
                    type="text"
                    [(ngModel)]="targetData.TextValue"
                  />
                </ng-template>
                <ng-template pTemplate="output">
                  <p-tag
                    [style]="{ background: valueColorForTarget(targetData) }"
                    [value]="valueTextForTarget(targetData)"
                  />
                </ng-template>
              </p-cellEditor>
            </td>
          }
          <td class="position-relative">
            {{ getUserDisplayName(targetData.UserID, targetData.UserFullName) || 'N/A' }}
            @if (targetData.ManuallyAddedDate) {
              <span 
                [pTooltip]="'Added Manually on ' + formatManuallyAddedDate(targetData.ManuallyAddedDate) + (targetData.ManuallyAddedByUser ? ' by ' + getUserNameFromViewModel(targetData.ManuallyAddedByUser) : '')"
                tooltipPosition="right"
                style="margin-left: 5px; display: inline-block; background-color: #3b82f6; color: white; border-radius: 50%; width: 20px; height: 20px; text-align: center; line-height: 20px; font-size: 12px; font-weight: bold; cursor: help;"
              >M</span>
            }
          </td>
          <td>
            {{ targetData.ModifiedByUser ? getUserNameFromViewModel(targetData.ModifiedByUser) : 'N/A' }}
          </td>
          <td>
            {{ targetData.ModifiedDate ? (targetData.ModifiedDate | date : "MM/dd/yyyy HH:mm") : 'N/A' }}
          </td>
          <td>
            <div class="flex align-items-center justify-content-center gap-2">
              <button
                *ngIf="!editingTargetData"
                pButton
                pRipple
                type="button"
                pInitEditableRow
                icon="pi pi-pencil"
                (click)="onRawDataEditInit(targetData)"
                class="p-button-rounded p-button-text"
              ></button>
              <button
                *ngIf="editingTargetData"
                pButton
                pRipple
                type="button"
                pSaveEditableRow
                icon="pi pi-check"
                (click)="onRawDataEditSave(targetData)"
                class="p-button-rounded p-button-text p-button-success mr-2"
              ></button>
              <button
                *ngIf="editingTargetData"
                pButton
                pRipple
                type="button"
                pCancelEditableRow
                icon="pi pi-times"
                (click)="onRawDataEditCancel(targetData)"
                class="p-button-rounded p-button-text p-button-danger"
              ></button>
            </div>
          </td>
          <td>
            <button
              *ngIf="!editingTargetData && !targetData.DeletedDate"
              pButton
              pRipple
              title="Delete data"
              type="button"
              icon="pi pi-trash"
              (click)="onRawDataDelete(targetData)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
            <button
              *ngIf="!editingTargetData && targetData.DeletedDate"
              pButton
              pRipple
              title="Restore data"
              type="button"
              icon="pi pi-refresh"
              (click)="onRawDataRestore(targetData)"
              class="p-button-rounded p-button-text p-button-success"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">There are no Target entries for this session.</td>
        </tr>
      </ng-template>
    </p-table>
    <button pButton type="button" label="Export to Excel" icon="pi pi-file-excel" (click)="exportExcel()"></button>
<app-loading-indicator *ngIf="isLoading"></app-loading-indicator>
